import { Link } from "react-scroll";
import { useState } from "react";
import "./Navbar.css";
import logo from "../assets/logo.png";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-inner">

        {/* LOGO */}
        <div className="nav-logo">
          <img src={logo} alt="Luxego Logo" />
          <div className="logo-text">
            <span className="brand">Luxego</span>
            <span className="tagline">Autospa on Wheels</span>
          </div>
        </div>

        {/* DESKTOP LINKS */}
        <ul className={`nav-links ${open ? "open" : ""}`}>
          <li>
            <Link to="home" smooth offset={-90} duration={500} onClick={() => setOpen(false)}>
              Home
            </Link>
          </li>
          <li>
            <Link to="packages" smooth offset={-90} duration={500} onClick={() => setOpen(false)}>
              Packages
            </Link>
          </li>
          <li>
            <Link to="reviews" smooth offset={-90} duration={500} onClick={() => setOpen(false)}>
              Reviews
            </Link>
          </li>
          <li>
            <Link to="booking" smooth offset={-90} duration={500} onClick={() => setOpen(false)}>
              Book Now
            </Link>
          </li>
          <li>
            <Link to="contact" smooth offset={-90} duration={500} onClick={() => setOpen(false)}>
              Contact
            </Link>
          </li>
        </ul>

        {/* RIGHT BUTTON */}
        <a href="tel:07721482404" className="call-btn">
          📞 Call Us
        </a>

        {/* MOBILE TOGGLE */}
        <div className="hamburger" onClick={() => setOpen(!open)}>
          <span />
          <span />
          <span />
        </div>

      </div>
    </nav>
  );
}
